import { Warning } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { MIN_MARGIN_THRESHOLD } from "@/utils/delivery-pricing";

type MarginWarningDialogProps = {
  open: boolean;
  margin: number;
  onConfirm: () => void;
  onCancel: () => void;
};

export function MarginWarningDialog({
  open,
  margin,
  onConfirm,
  onCancel,
}: MarginWarningDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, color: "warning.main" }}>
        <Warning />
        Marge insuffisante
      </DialogTitle>
      <DialogContent>
        <Box sx={{ textAlign: "center", py: 2 }}>
          <Typography variant="h4" color="warning.main" fontWeight="bold">
            {(margin * 100).toFixed(1)}%
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
            La marge actuelle est inférieure au seuil recommandé de{" "}
            {(MIN_MARGIN_THRESHOLD * 100).toFixed(0)}%.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            Voulez-vous continuer malgré tout ?
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} variant="outlined" color="inherit">
          Annuler
        </Button>
        <Button onClick={onConfirm} variant="contained" color="warning">
          Confirmer quand même
        </Button>
      </DialogActions>
    </Dialog>
  );
}
